// ======================= Imports =======================
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { api } from "./utility/AxiosInceptor";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "./app/store/auth/AuthSlice";
import { InputText } from "primereact/inputtext";
import { ListBox } from "primereact/listbox";
import "./apptopbar.css";
import { FileUpload } from "primereact/fileupload";
import { useFormik } from "formik";
import * as Yup from "yup";
import "../public/setting.svg";
import "../public/user.svg";
import { Toast } from "primereact/toast";
import "./app.css";
import { InputSwitch } from "primereact/inputswitch";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import {
  DarkTheme,
  Edit,
  Home,
  Loginbg,
  LogoutIcon,
  NotificationIcon,
  Prepaidnotification,
  ProfilesettingIcon,
  SearchIco,
} from "./utility";
import io from "socket.io-client";
import moment from "moment";

// ======================= Main Component =======================
export const AppTopbar = (props) => {
  // ======================= State Management =======================
  const socket = useRef(null);
  const [visibleRight, setVisibleRight] = useState(false);
  const location = useLocation();
  const [counter, setCounter] = useState("");
  const [currentLocation, setCurrentLocation] = useState(location.pathname);
  const [CustomerProfileIcon, setCustomerProfileIcon] = useState(false);
  const [allNotification, setAllNotification] = useState(true);
  const [unreadNotification, setUnreadNotification] = useState(false);
  const [visibleSearch, setVisibleSearch] = useState(false);
  const [notification, setNotification] = useState([]);
  const [profileSetting, setProfileSetting] = useState(false);
  const [showeditprofile, setShoweditprofile] = useState(false);
  const [isDeleteChecked, setIsDeleteChecked] = useState(false);
  const [checked, setChecked] = useState(false);
  const [userdropdown, setUserDropdown] = useState(false);
  const [uploadedFilePath, setUploadedFilePath] = useState(null);
  const [department, setDepartment] = useState("");
  const [userData1, setUserData1] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("Upload");
  const [notesidebar, setnotesidebar] = useState(false);
  const [monthlyNote, setMonthlyNotes] = useState(false);
  const [weeklyNotes, setWeeklyNotes] = useState(false);
  const [active, setActive] = useState(false);
  const [refreshUserData, setRefreshUserData] = useState(false);
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  // ======================= User Data & Validation =======================
  let userData = JSON.parse(localStorage.getItem("userData"));
  let toast = useRef();
  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required("This is Required"),
  });

  // ======================= Formik Setup =======================
  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      fullName: userData?.userName,
    },
    onSubmit: () => {
      handleUpload();
    },
  });

  // ======================= Notification Logic =======================
  const unreadNotes = notification?.filter((item) => !item?.read);

  // ======================= User Details Fetch =======================
  const userdetail = useCallback(async () => {
    try {
      const res = await api.get(
        `/api/web/user/userDetails?userId=${userData?._id}`,
      );
      setUserData1(res?.data?.data);
    } catch (e) {}
  }, [userData._id]); // only re-creates when userId changes

  useEffect(() => {
    userdetail();
  }, [userdetail, refreshUserData]);

  // ======================= Department Fetch =======================
  useEffect(() => {
    api
      .get(
        `/api/deparments/getDepartmentById?departmentId=${userData?.department}`,
      )
      .then((response) => {
        setDepartment(response?.data?.data?.department);
      })
      .catch((error) => {});
  }, [userData.department]);

  // ======================= Route Change Handling =======================
  useEffect(() => {
    const handleRouteChange = (newLocation) => {
      if (newLocation.pathname !== currentLocation) {
        props.setSearchBy(null);
        props.setSearchByValueClick(false);
        setCurrentLocation(newLocation.pathname);
      }
    };
    handleRouteChange(location);
    window.addEventListener("popstate", handleRouteChange);
    return () => {
      window.removeEventListener("popstate", handleRouteChange);
    };
  }, [currentLocation, location, props]);

  // ======================= Document Click for Search =======================
  useEffect(() => {
    document.addEventListener("click", docOnClick, false);
  });

  function docOnClick() {
    setVisibleSearch(false);
  }

  // ======================= Socket.IO for Notifications =======================
  const fetchNotifications = useCallback(async () => {
    try {
      const response = await api.get(
        `/api/web/notes/notifications?userId=${parseLoginRes?._id}`,
      );
      const data = response?.data?.unreadCount;
      const note = response?.data?.notifications;
      setNotification(note);
      setCounter(data);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Note",
        detail: error?.response?.data?.msg,
      });
    }
  }, [parseLoginRes._id]); // stable dependency

  useEffect(() => {
    socket.current = io(process.env.REACT_APP_BASE_URL, {
      transports: ["websocket"],
    });

    socket.current.on("connect", () => {});

    socket.current.on("newNote", fetchNotifications);
    socket.current.on("error", (err) => {});

    fetchNotifications();

    return () => {
      socket.current.disconnect();
    };
  }, [fetchNotifications]);
  // ======================= Body Overflow Handling for Apps =======================
  useEffect(() => {
    if (props.showApps) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflowY = "auto";
      document.body.style.overflowX = "hidden";
    }
    return () => {
      document.body.style.overflowY = "auto";
      document.body.style.overflowX = "hidden";
    };
  }, [props.showApps]);

  // ======================= Advance Search ListBox =======================
  const countries = [{ name: "Advance Search", code: "advance search" }];
  const countryTemplate = (option) => {
    return (
      <div className="flex listbox-container align-items-center">
        {option.name === "Advance Search" ? (
          <i
            style={{
              fontSize: "1.6rem",
              marginRight: "1rem",
              color: "#72728f",
            }}
            className="pi pi-search-plus"
          />
        ) : (
          <img
            onError={(e) => {
              e.target.src = "./placeholderimage.jpg";
            }}
            src="/images/Dashboard-Search/inventory-search.png"
            alt="none"
          />
        )}
        <p
          style={{
            padding: "0rem",
            margin: "0rem",
            color: "#72728f",
            fontWeight: "500",
            fontFamily: "Inter",
          }}
        >
          {option.name}
        </p>
      </div>
    );
  };

  // ======================= Redux & Navigation =======================
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    if (parseLoginRes?.companyName) {
      setCompanyName(parseLoginRes.companyName.toUpperCase());
    }
  }, [parseLoginRes]);

  // ======================= Logout Handler =======================
  const handleLogout = () => {
    props.setSearchValue("");
    props.setSearchByValueClick(false);
    props.setSearchBy(null);
    dispatch(logout());
    navigate("/login");
  };

  // ======================= Notification Read Handler =======================
  const handleReadNotification = async (notificationId) => {
    try {
      await api.put(
        `/api/web/notes/markReadnotifications?notificationId=${notificationId}&userId=${parseLoginRes?._id}`,
      );
      api.put(
        `/api/web/notes/markReadnotifications?notificationId=${notificationId}&userId=${parseLoginRes?._id}`,
      );

      const res = await api.get(
        `/api/web/notes/notifications?userId=${parseLoginRes?._id}`,
      );
      const { unreadCount, notifications } = res?.data;
      setNotification(notifications);
      setCounter(unreadCount);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Note",
        detail: error?.response?.data?.msg,
      });
    }
  };

  // ======================= Navigation Handler for Notification =======================
  const handleNavigate = (customerId) => {
    if (customerId !== undefined) {
      if (location.pathname === "/customer-profile") {
        props.setShowApps(false);
        localStorage.setItem("selectedId", JSON.stringify(customerId));
        props.setRefreshOnNotification(customerId);
      } else {
        localStorage.setItem("selectedId", JSON.stringify(customerId));
        navigate("/customer-profile", { state: { selectedId: customerId } });
        props.setShowApps(false);
      }
    }
  };

  // ======================= File Upload Handler =======================
  const customBase64Uploader = (event) => {
    setIsDeleteChecked(false);
    const file = event.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setUploadedFileName(file.name);
      setUploadedFilePath(file);
    };
    reader.readAsDataURL(file);
  };

  // ======================= Profile Image Upload/Update Handler =======================
  const handleUpload = async () => {
    try {
      if (isDeleteChecked && !uploadedFilePath) {
        // Delete profile image
        const res = await api.delete(
          `/api/web/user/deleteProfileImage?UserId=${userData?._id}`,
        );
        toast.current.show({
          severity: "success",
          summary: "Profile Image",
          detail: res?.data?.msg || "Profile image deleted successfully.",
        });

        // Update name separately if it changed
        if (formik.values.fullName !== userData?.userName) {
          await api.put(`/api/web/user/updateProfileImage`, {
            UserId: userData?._id,
            name: formik.values.fullName,
          });
        }
      } else {
        // Upload new image and/or update name
        const formData = new FormData();
        formData.append("UserId", userData?._id);
        formData.append("profileImage", uploadedFilePath);
        formData.append("name", formik.values.fullName);

        const response = await api.put(
          `/api/web/user/updateProfileImage`,
          formData,
        );

        if (response.status === 200 || response.status === 201) {
          toast.current.show({
            severity: "success",
            summary: "User Profile",
            detail: response?.data?.msg || "Profile updated successfully.",
          });
        }
      }

      // Update local storage and UI
      const updatedUserData = {
        ...userData,
        userName: formik.values.fullName,
      };
      localStorage.setItem("userData", JSON.stringify(updatedUserData));

      setRefreshUserData((prev) => !prev);
      setTimeout(() => {
        setProfileSetting((prev) => !prev);
      }, 500);
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Profile Update",
        detail: error?.response?.data?.msg || "Failed to update profile.",
      });
    }
  };

  // ======================= User Dropdown Close on Click =======================
  useEffect(() => {
    document.addEventListener(
      "click",
      (e) => {
        setUserDropdown(false);
      },
      false,
    );
  }, []);

  // ======================= Render =======================
  return (
    <div>
      <Toast ref={toast} />
      {!props.showApps ? (
        <div className="notshowapps-main">
          <div className="hamburgur">
            <button
              type="button"
              className="layout-menu-button layout-topbar-button"
              onClick={props.onToggleMenuClick}
            >
              <i
                style={{
                  fontSize: "1.25em",
                  marginTop: "-0.5rem",
                  display: "inline-block",
                  color: "rgb(112, 134, 253)",
                }}
                className="pi pi-bars"
              />
            </button>
          </div>
          <div
            style={{ zIndex: 1001 }}
            className="layout-topbar"
            onClick={(e) => {
              setProfileSetting(false);
              setUserDropdown(false);
              setVisibleRight(false);
              setVisibleSearch(false);
              e.stopPropagation();
            }}
          >
            <div className="w-full flex flex-wrap flex-row justify-content-between align-items-start">
              <div
                style={{ width: "72.5rem" }}
                className="flex logo-search flex-wrap flex-row justify-content-between align-items-center"
              >
                <div
                  style={{
                    marginTop: (
                      companyName.includes("MAGNET")
                        ? "-2rem"
                        : companyName.includes("ZASONE")
                    )
                      ? "-1rem"
                      : companyName.includes("TALK")
                        ? "-1rem"
                        : companyName.includes("DIVERSE")
                          ? "-2rem"
                          : "0rem",
                  }}
                  className="sidebar-company-logo flex flex-wrap flex-row justify-content-center"
                >
                  <Link
                    to="/"
                    className=""
                    onClick={(e) => {
                      props.setShowApps(false);
                      e.stopPropagation();
                      props.setSearchBy(null);
                      props.setSearchByValueClick(false);
                    }}
                  >
                    <img
                      onError={(e) => {
                        e.target.src = "./placeholderimage.jpg";
                      }}
                      style={{
                        height: (
                          companyName.includes("MAGNET")
                            ? "150%"
                            : companyName.includes("ZASONE")
                        )
                          ? "120%"
                          : companyName.includes("TALK")
                            ? "110%"
                            : companyName.includes("DIVERSE")
                              ? "140%"
                              : "100%",
                        marginLeft: companyName?.includes("MAGNET")
                          ? "1.4rem"
                          : companyName.includes("ZASONE")
                            ? "4rem"
                            : companyName.includes("TALK")
                              ? "2rem"
                              : companyName.includes("DIVERSE") && "1.2rem",
                        marginTop: companyName?.includes("ZASONE") && "-0.5rem",
                      }}
                      src={`${companyName.includes("IJ") ? "/companyLogo1.png" : companyName.includes("ZISFONE") ? "/zisfonelogo.png" : companyName.includes("MAGNET") ? "/magnetlogo.png" : companyName.includes("ZASONE") ? "/zasone.png" : companyName.includes("TALK") ? "/Talkdaily.png" : companyName.includes("DIVERSE") ? "/Diverse_Mobile.png" : "/defaultLogo.png"}`}
                      alt="Logo"
                    />
                  </Link>
                </div>

                <div className="flex flex-wrap flex-row justify-content-center align-items-center topbarsearchmain">
                  <div style={{ position: "relative", width: "100%" }}>
                    <span
                      style={{
                        position: "absolute",
                        left: "1rem",
                        top: "55%",
                        transform: "translateY(-50%)",
                        zIndex: 1,
                      }}
                    >
                      <SearchIco />
                    </span>
                    <InputText
                      className="topbarsearch"
                      onChange={(e) => {
                        props.setSearchValue(e.target.value);
                      }}
                      value={props.searchValue}
                      onKeyDown={(e) => {
                        e.stopPropagation();
                        if (e.key === "Enter") {
                          e.stopPropagation();
                          if (props.searchValue !== "") {
                            props.setSearchBy(null);
                            props.setShowApps(false);
                            props.setSearchByValueClick(true);
                            props.setCallSearchApi((prev) => !prev);
                          }
                          setVisibleSearch(false);
                        }
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        // if (props.searchValue !== "") {

                        //     props.setSearchByValueClick(true);
                        //     props.setCallSearchApi((prev) => !prev);
                        // }
                        setVisibleSearch(true);
                      }}
                      placeholder="Search Customer"
                      style={{
                        backgroundColor: "transparent",
                        paddingLeft: "4rem",
                        width: "40.8rem",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="buttonsdiv align-items-start">
                <div
                  className="appbutton"
                  onClick={() => {
                    props.setShowApps(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <span className="app-span flex justify-content-center align-items-center gradient-text">
                    <Home />
                  </span>
                </div>
                <div
                  className="appbutton"
                  style={{ cursor: "pointer", background: "white" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setVisibleRight((prev) => !prev);
                  }}
                  onMouseEnter={() => {
                    setActive(true);
                  }}
                  onMouseLeave={() => {
                    setActive(false);
                  }}
                >
                  <div>
                    <span className="notification-span flex justify-content-center align-items-center gradient-text">
                      <NotificationIcon />
                    </span>
                  </div>
                  <span
                    className="notification-count"
                    style={{
                      backgroundColor: active ? "white" : "transparent",
                    }}
                  >
                    {counter <= 99 ? counter : "99+"}
                  </span>
                </div>
                <div
                  className="userlogin cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();

                    setUserDropdown((prev) => !prev);
                  }}
                >
                  {userData1?.picture ? (
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "0.4rem",
                      }}
                      src={`${process.env.REACT_APP_BASE_URL}/${userData1.picture.replace(/^uploads\//, "")}`}
                      alt={userData1?.name || "User"}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  ) : (
                    <span className="profilename">
                      {userData1?.name
                        ? userData1.name
                            .split(" ") // Split the name into words
                            .map((word) => word.charAt(0).toUpperCase()) // Get the first letter of each word and capitalize
                            .join("") // Join the letters
                        : "NA"}{" "}
                      {/* Default fallback */}
                    </span>
                  )}
                </div>
              </div>
              {userdropdown && (
                <div
                  className="profilemenu"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <div className="profilemenuinner">
                    <div className="info w-full">
                      <div className="userinfo">
                        <div className="profuser">
                          {userData1?.picture ? (
                            <img
                              className="imgmargin"
                              src={`${process.env.REACT_APP_BASE_URL}/${userData1.picture.replace(/^uploads\//, "")}`}
                              alt={userData1?.name || "User"}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          ) : (
                            <div className="flex justify-content-center align-items-center imgmargin">
                              <span
                                className="profilename"
                                onClick={() => {
                                  setUserDropdown((prev) => !prev);
                                }}
                              >
                                {userData1?.name
                                  ? userData1.name
                                      .split(" ") // Split the name into words
                                      .map((word) =>
                                        word.charAt(0).toUpperCase(),
                                      ) // Get the first letter of each word and capitalize
                                      .join("") // Join the letters
                                  : "NA"}{" "}
                                {/* Default fallback */}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="userinfo">
                        <h1 style={{ paddingTop: "0.1rem", height: "1.3rem" }}>
                          {userData1?.name}
                        </h1>
                        <p>{userData?.email}</p>
                      </div>
                      <div style={{ marginTop: "-2.4rem" }} className="userbtn">
                        {userData?.role?.role}
                      </div>
                    </div>
                    <div
                      className="data w-full"
                      onClick={() => {
                        setProfileSetting((prev) => !prev);
                        setUserDropdown((prev) => !prev);
                      }}
                    >
                      <div>
                        <ProfilesettingIcon />
                      </div>
                      <div>
                        <span style={{ marginLeft: "0.5rem" }}>
                          {" "}
                          Profile Settings
                        </span>
                      </div>
                    </div>

                    <div className="data1 w-full">
                      <div>
                        <DarkTheme />
                      </div>
                      <div>
                        <span style={{ marginLeft: "0.5rem" }}> Dark Mode</span>
                      </div>
                      <div
                        className="flex justify-content-center align-items-center"
                        style={{ marginLeft: "32%" }}
                      >
                        <InputSwitch
                          checked={checked}
                          onChange={(e) => setChecked(e.value)}
                        />
                      </div>
                    </div>

                    <div
                      className="data2 w-full"
                      onClick={() => {
                        handleLogout();
                        setUserDropdown((prev) => !prev);
                      }}
                    >
                      <div>
                        <LogoutIcon />
                      </div>
                      <div>
                        <span style={{ marginLeft: "0.5rem" }}> Logout</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              style={{ background: "#FFFFFF" }}
              className="flex justify-content-center listbox"
            >
              <ListBox
                value={props.searchBy}
                style={{
                  display: `${visibleSearch === true ? "block" : "none"}`,
                  backgroundColor: "#FFFFFF",
                }}
                onChange={(e) => {
                  if (e.value !== null) {
                    props.setShowApps(false);
                    props.setSearchByValueClick(false);
                    props.setSearchBy(e.value);
                    setVisibleSearch(false);
                  }
                }}
                options={countries}
                optionLabel="name"
                onClick={(e) => {
                  e.stopPropagation();
                  if (e.target.textContent === "Advance Search") {
                  }
                }}
                itemTemplate={countryTemplate}
                className="w-full "
                listStyle={{ maxHeight: "25rem" }}
              />
            </div>
            <div className="flex ">
              <Sidebar
                onClick={(e) => {
                  e.stopPropagation();
                }}
                closeable={false}
                style={{ width: "40.8rem" }}
                visible={visibleRight}
                position="right"
                onHide={() => setVisibleRight(false)}
              >
                <div
                  className="flex justify-content-start align-items-center"
                  style={{
                    height: "2.5rem",
                    width: "11.6rem",
                    marginTop: "1.5rem",
                  }}
                >
                  <button
                    className={allNotification ? "allbtnactive" : "allbtn"}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      setUnreadNotification(false);
                      setAllNotification(true);
                    }}
                  >
                    ALL
                  </button>
                  <button
                    className={
                      unreadNotification ? "unreadbtnactive" : "unreadbtn"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      setUnreadNotification(true);
                      setAllNotification(false);
                    }}
                  >
                    Unread
                  </button>
                </div>
                <hr />{" "}
                {unreadNotification
                  ? unreadNotes?.map((item, index) => (
                      <div
                        key={index}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          props.setSearchBy(null);
                          props.setSearchByValueClick(false);
                          handleNavigate(item?.customerId);
                          setVisibleRight(false);
                          handleReadNotification(item?._id);
                          props.setHandleHighlight(item?.noteId);
                        }}
                        className={
                          item?.read ? "notificationread" : "notificationunread"
                        }
                      >
                        <div
                          className="innernotification flex align-items-start justify-content-start "
                          style={{ marginLeft: "-1.5rem" }}
                        >
                          {/* <div className="tooltip-container">
                                                      <Prepaidnotification />
                                                      <span className="custom-tooltip"> ToolTip</span>
                                                  </div> */}
                          <div
                            className="flex flex-column align-items-start justify-content-start ml-4"
                            style={{ paddingTop: "0.2rem" }}
                          >
                            {/* <h2>New Prepaid SIM Activation Request</h2> */}
                            <p>{item.message}</p>
                            <span style={{ cursor: "pointer" }}>
                              <h5
                                style={{ fontSize: "1.2rem" }}
                                onClick={() => {
                                  handleReadNotification(item?._id);
                                }}
                              >
                                {item?.timestamp &&
                                  moment
                                    .utc(item?.timestamp) // Convert UTC to Moment object
                                    .tz("America/New_York") // Convert to Eastern Time (ET)
                                    .format("dddd, MMM D")}
                              </h5>
                            </span>
                          </div>
                        </div>
                      </div>
                    ))
                  : notification?.map((item, index) => (
                      <div
                        key={index}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          props.setSearchBy(null);
                          props.setSearchByValueClick(false);
                          handleNavigate(item?.customerId);
                          setVisibleRight(false);
                          handleReadNotification(item?._id);
                          props.setHandleHighlight(item?.noteId);
                        }}
                        className={
                          item?.read ? "notificationread" : "notificationunread"
                        }
                      >
                        <div
                          className="innernotification flex align-items-start justify-content-start "
                          style={{ marginLeft: "-1.5rem" }}
                        >
                          {/* <div className="tooltip-container">
                                                      <Prepaidnotification />
                                                      <span className="custom-tooltip"> ToolTip</span>
                                                  </div> */}
                          <div
                            className="flex flex-column align-items-start justify-content-start ml-4"
                            style={{ paddingTop: "0.2rem" }}
                          >
                            {/* <h2>New Prepaid SIM Activation Request</h2> */}
                            <p>{item.message}</p>
                            <span style={{ cursor: "pointer" }}>
                              <h5
                                style={{ fontSize: "1.2rem" }}
                                onClick={() => {
                                  handleReadNotification(item?._id);
                                }}
                              >
                                {item?.timestamp &&
                                  moment
                                    .utc(item?.timestamp) // Convert UTC to Moment object
                                    .tz("America/New_York") // Convert to Eastern Time (ET)
                                    .format("dddd, MMM D")}
                              </h5>
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
              </Sidebar>
            </div>

            {/* Userprofile sidebar */}

            <div className="flex justify-content-center align-items-center  ">
              <Sidebar
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="flex justify-content-center align-items-center "
                closeable={false}
                style={{ width: "80.8rem" }}
                visible={profileSetting}
                position="right"
                onHide={() => setProfileSetting(false)}
              >
                {showeditprofile ? (
                  <div>
                    <div className="userprofilemain">
                      <div className="profileinfo">
                        <div className="profilename">
                          <div>
                            <button>
                              {userData1?.picture ? (
                                <img
                                  style={{
                                    width: "8rem",
                                    height: "8rem",
                                    marginleft: "-1rem",
                                  }}
                                  src={`${process.env.REACT_APP_BASE_URL}/${userData1.picture.replace(/^uploads\//, "")}`}
                                  alt={userData1?.name || "User"}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              ) : (
                                <span
                                  className="profilename"
                                  onClick={() => setUserDropdown(true)}
                                  style={{
                                    fontSize: "2.8rem",
                                    fontWeight: "500",
                                    color: "#9C9EB6",
                                  }}
                                >
                                  {userData1?.name
                                    ? userData1.name
                                        .split(" ") // Split the name into words
                                        .map((word) =>
                                          word.charAt(0).toUpperCase(),
                                        ) // Get the first letter of each word and capitalize
                                        .join("") // Join the letters
                                    : "NA"}{" "}
                                  {/* Default fallback */}
                                </span>
                              )}
                            </button>
                          </div>
                          <div className="mailinfoedit">
                            <button
                              className={` ${isDeleteChecked ? "deletepiccheck" : "deletepic"}`}
                              onClick={() => {
                                setIsDeleteChecked((prev) => !prev);
                              }}
                            >
                              Delete Picture
                            </button>
                            <div>
                              <div>
                                <FileUpload
                                  mode="basic"
                                  name="demo[]"
                                  accept="image/*"
                                  customUpload
                                  uploadHandler={customBase64Uploader}
                                  chooseLabel={uploadedFileName}
                                  auto
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="profileeditbtn"
                          onClick={() => {
                            setShoweditprofile(true);
                          }}
                        >
                          <span className="actionbtnmain">
                            <Edit />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="userprofiledetails">
                      <div className="userprofiledetailsinner">
                        <div className="flex flex-row w-full justify-content-between">
                          <div>
                            <h1>Details</h1>
                          </div>
                        </div>
                        <div className="flex flex-column w-full justify-content-between mt-2">
                          <div className="flex w-full justify-content-between">
                            <label
                              className={
                                formik.touched.fullName &&
                                formik.errors.fullName
                                  ? "labelerr"
                                  : " "
                              }
                            >
                              Full Name
                            </label>
                            {formik.touched.fullName &&
                            formik.errors.fullName ? (
                              <span className="err">
                                {formik.errors.fullName}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <InputText
                            id="fullName"
                            className={
                              formik.touched.fullName && formik.errors.fullName
                                ? "inputfielderr mt-2"
                                : "inputfield mt-2"
                            }
                            type="text"
                            value={formik.values.fullName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          ></InputText>
                        </div>

                        <div className="flex flex-column w-full justify-content-between mt-5">
                          <label> Company Name</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={userData?.companyName}
                            disabled
                          ></InputText>
                        </div>
                        <div className="flex flex-column w-full justify-content-between mt-5">
                          <label>Email</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={userData?.email}
                            disabled
                          ></InputText>
                        </div>
                        <div className="flex flex-column w-full justify-content-between mt-5">
                          <label>Role</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={userData?.role?.role}
                            disabled
                          ></InputText>
                        </div>
                        <div
                          className="flex flex-column w-full justify-content-between mt-5"
                          style={{ marginBottom: "4rem" }}
                        >
                          <label> Department</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={department}
                            disabled
                          ></InputText>
                        </div>
                        <div className="flex w-full justify-content-end">
                          <button
                            className="backbtn"
                            onClick={() => {
                              formik.setFieldValue(
                                "fullName",
                                userData.userName,
                              );
                              setShoweditprofile(false);
                            }}
                          >
                            Back
                          </button>
                          <div
                            className=" flex justify-content-center"
                            style={{ marginLeft: "1rem" }}
                          >
                            <Button
                              type="submit"
                              label="Update"
                              className="submitbtn"
                              onClick={() => {
                                formik.handleSubmit();
                                setProfileSetting((prev) => !prev);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="userprofilemain">
                      <div className="profileinfo">
                        <div className="profilename">
                          <div>
                            <button>
                              {userData1?.picture ? (
                                <img
                                  style={{
                                    width: "8rem",
                                    height: "8rem",
                                    marginleft: "-1rem",
                                  }}
                                  src={`${process.env.REACT_APP_BASE_URL}/${userData1.picture.replace(/^uploads\//, "")}`}
                                  alt={userData1?.name || "User"}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              ) : (
                                <span
                                  className="profilename"
                                  onClick={() => setUserDropdown(true)}
                                  style={{
                                    fontSize: "2.8rem",
                                    fontWeight: "500",
                                    color: "#9C9EB6",
                                  }}
                                >
                                  {userData1?.name
                                    ? userData1.name
                                        .split(" ") // Split the name into words
                                        .map((word) =>
                                          word.charAt(0).toUpperCase(),
                                        ) // Get the first letter of each word and capitalize
                                        .join("") // Join the letters
                                    : "NA"}{" "}
                                  {/* Default fallback */}
                                </span>
                              )}
                            </button>
                          </div>
                          <div className="mailinfo">
                            <h1>{userData1?.name}</h1>
                            <p>{userData?.email}</p>
                          </div>
                        </div>
                        <div
                          className="profileeditbtn"
                          onClick={() => {
                            setShoweditprofile(true);
                          }}
                        >
                          <span className="actionbtnmain">
                            {" "}
                            <Edit />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="userprofiledetails">
                      <div className="userprofiledetailsinner">
                        <div className="flex flex-row w-full justify-content-between">
                          <div>
                            <h1>Details</h1>
                          </div>
                          {/* <div>
                                                        <h5>
                                                            User Id : <span> ETC12345</span>
                                                        </h5>
                                                    </div> */}
                        </div>
                        <div className="flex flex-column w-full justify-content-between mt-5">
                          <label> Full Name</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={formik.values.fullName}
                            contentEditable={false}
                          ></InputText>
                        </div>
                        {/* <div className="flex flex-column w-full justify-content-between mt-5">
                                                    <label> Last Name</label>
                                                    <InputText className="inputfield mt-2" type="text" value={"Wick"} contentEditable={false}></InputText>
                                                </div> */}
                        <div className="flex flex-column w-full justify-content-between mt-5">
                          <label> Company Name</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={userData?.companyName}
                            contentEditable={false}
                          ></InputText>
                        </div>
                        <div className="flex flex-column w-full justify-content-between mt-5">
                          <label>Email</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={userData?.email}
                            contentEditable={false}
                          ></InputText>
                        </div>
                        <div className="flex flex-column w-full justify-content-between mt-5">
                          <label>Role</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={userData?.role?.role}
                            contentEditable={false}
                          ></InputText>
                        </div>
                        <div
                          className="flex flex-column w-full justify-content-between mt-5"
                          style={{ marginBottom: "4rem" }}
                        >
                          <label> Department</label>
                          <InputText
                            className="inputfield mt-2"
                            type="text"
                            value={department}
                            contentEditable={false}
                          ></InputText>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Sidebar>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="appdialog" style={{ position: "relative" }}>
            <div
              style={{ zIndex: 99999 }}
              className="layout-topbar"
              onClick={(e) => {
                setProfileSetting(false);
                setVisibleRight(false);
                setVisibleSearch(false);
                setUserDropdown(false);
                e.stopPropagation();
              }}
            >
              <div className="w-full flex flex-wrap flex-row justify-content-between align-items-start">
                <div
                  style={{ width: "72.5rem" }}
                  className="flex logo-search flex-wrap flex-row justify-content-between align-items-center"
                >
                  <div
                    style={{
                      marginTop: (
                        companyName.includes("MAGNET")
                          ? "-2rem"
                          : companyName.includes("ZASONE")
                      )
                        ? "-1rem"
                        : companyName.includes("TALK")
                          ? "-1rem"
                          : companyName.includes("DIVERSE")
                            ? "-2rem"
                            : "0rem",
                    }}
                    className="sidebar-company-logo flex flex-wrap flex-row justify-content-center"
                  >
                    <Link
                      to="/"
                      className=""
                      onClick={(e) => {
                        props.setShowApps(false);
                        e.stopPropagation();
                        props.setSearchBy(null);
                        props.setSearchByValueClick(false);
                      }}
                    >
                      <img
                        onError={(e) => {
                          e.target.src = "./placeholderimage.jpg";
                        }}
                        style={{
                          height: (
                            companyName.includes("MAGNET")
                              ? "150%"
                              : companyName.includes("ZASONE")
                          )
                            ? "120%"
                            : companyName.includes("TALK")
                              ? "110%"
                              : companyName.includes("DIVERSE") && "140%",
                          marginLeft: companyName?.includes("MAGNET")
                            ? "1.4rem"
                            : companyName.includes("ZASONE")
                              ? "4rem"
                              : companyName.includes("TALK")
                                ? "2rem"
                                : companyName.includes("DIVERSE")
                                  ? "1.2rem"
                                  : "0rem",
                          marginTop:
                            companyName?.includes("ZASONE") && "-0.5rem",
                        }}
                        src={`${companyName.includes("IJ") ? "/companyLogo1.png" : companyName.includes("ZISFONE") ? "/zisfonelogo.png" : companyName.includes("MAGNET") ? "/magnetlogo.png" : companyName.includes("ZASONE") ? "/zasone.png" : companyName.includes("TALK") ? "/Talkdaily.png" : companyName.includes("DIVERSE") ? "/Diverse_Mobile.png" : "/defaultLogo.png"}`}
                        alt="Logo"
                      />
                    </Link>
                  </div>
                  <div className="flex flex-wrap flex-row justify-content-center align-items-center topbarsearchmain">
                    <div style={{ position: "relative", width: "100%" }}>
                      <span
                        style={{
                          position: "absolute",
                          left: "1rem",
                          top: "55%",
                          transform: "translateY(-50%)",
                          zIndex: 1,
                        }}
                      >
                        <SearchIco />
                      </span>
                      <InputText
                        className="topbarsearch"
                        onChange={(e) => {
                          props.setSearchValue(e.target.value);
                        }}
                        value={props.searchValue}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.stopPropagation();
                            if (props.searchValue !== "") {
                              props.setSearchBy(null);
                              props.setShowApps(false);
                              props.setSearchByValueClick(true);
                              props.setCallSearchApi((prev) => !prev);
                            }
                            setVisibleSearch(false);
                          }
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          // if (props.searchValue !== "") {
                          //     props.setSearchByValueClick(true);
                          //     props.setCallSearchApi((prev) => !prev);
                          // }
                          setVisibleSearch(true);
                        }}
                        placeholder="Search Customer"
                        style={{
                          backgroundColor: "transparent",
                          paddingLeft: "4rem",
                          width: "40.8rem",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="buttonsdiv align-items-start">
                  <div
                    className="appbutton"
                    onClick={() => props.setShowApps(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="app-span flex justify-content-center align-items-center gradient-text">
                      <Home />
                    </span>
                  </div>
                  <div
                    className="appbutton"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setVisibleRight((prev) => !prev);
                    }}
                  >
                    <div>
                      <span className="notification-span flex justify-content-center align-items-center gradient-text">
                        <NotificationIcon />
                      </span>
                    </div>
                    <span
                      style={{ color: "black" }}
                      className=" notification-count"
                    >
                      {counter <= 9 ? counter : "9+"}
                    </span>
                  </div>

                  <div
                    className="userlogin cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      setUserDropdown(true);
                    }}
                  >
                    <div className="main-p  flex justify-content-center  align-items-center ">
                      {userData1?.picture ? (
                        <img
                          src={`${process.env.REACT_APP_BASE_URL}/${userData1.picture.replace(/^uploads\//, "")}`}
                          alt={userData1?.name || "User"}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        <span className="profilename">
                          {userData1?.name
                            ? userData1.name
                                .split(" ") // Split the name into words
                                .map((word) => word.charAt(0).toUpperCase()) // Get the first letter of each word and capitalize
                                .join("") // Join the letters
                            : "NA"}{" "}
                          {/* Default fallback */}
                        </span>
                      )}
                    </div>
                  </div>
                  {userdropdown && (
                    <div
                      className="profilemenu"
                      onMouseLeave={() => setUserDropdown(false)}
                    >
                      <div className="profilemenuinner">
                        <div className="info w-full">
                          <div className="userinfo">
                            <div className="profuser">
                              {userData1?.picture ? (
                                <img
                                  className="imgmargin"
                                  src={`${process.env.REACT_APP_BASE_URL}/${userData1.picture.replace(/^uploads\//, "")}`}
                                  alt={userData1?.name || "User"}
                                  onError={(e) => {
                                    e.target.style.display = "none";
                                  }}
                                />
                              ) : (
                                <div className="flex justify-content-center align-items-center imgmargin">
                                  <span
                                    className="profilename"
                                    onClick={() =>
                                      setUserDropdown((prev) => !prev)
                                    }
                                  >
                                    {userData1?.name
                                      ? userData1.name
                                          .split(" ") // Split the name into words
                                          .map((word) =>
                                            word.charAt(0).toUpperCase(),
                                          ) // Get the first letter of each word and capitalize
                                          .join("") // Join the letters
                                      : "NA"}{" "}
                                    {/* Default fallback */}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="userinfo">
                            <h1
                              style={{ paddingTop: "0.1rem", height: "1.3rem" }}
                            >
                              {userData1?.name}
                            </h1>
                            <p>{userData?.email}</p>
                          </div>
                          <div
                            style={{ marginTop: "-2.4rem" }}
                            className="userbtn"
                          >
                            {userData?.role?.role}
                          </div>
                        </div>
                        <div
                          className="data w-full"
                          onClick={() => {
                            setProfileSetting((prev) => !prev);
                            setUserDropdown((prev) => !prev);
                          }}
                        >
                          <div>
                            <ProfilesettingIcon />
                          </div>
                          <div>
                            <span style={{ marginLeft: "0.5rem" }}>
                              {" "}
                              Profile Settings
                            </span>
                          </div>
                        </div>

                        <div className="data1 w-full">
                          <div>
                            <DarkTheme />
                          </div>
                          <div>
                            <span style={{ marginLeft: "0.5rem" }}>
                              {" "}
                              Dark Mode
                            </span>
                          </div>
                          <div
                            className="flex justify-content-center align-items-center"
                            style={{ marginLeft: "32%" }}
                          >
                            <InputSwitch
                              checked={checked}
                              onChange={(e) => setChecked(e.value)}
                            />
                          </div>
                        </div>

                        <div
                          className="data2 w-full"
                          onClick={() => {
                            handleLogout();
                            setUserDropdown((prev) => !prev);
                          }}
                        >
                          <div>
                            <LogoutIcon />
                          </div>
                          <div>
                            <span style={{ marginLeft: "0.5rem" }}>
                              {" "}
                              Logout
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                style={{ background: "#FFFFFF" }}
                className="flex justify-content-center listbox"
              >
                <ListBox
                  value={props.searchBy}
                  style={{
                    display: `${visibleSearch === true ? "block" : "none"}`,
                    backgroundColor: "#FFFFFF",
                  }}
                  onChange={(e) => {
                    if (e.value !== null) {
                      props.setShowApps(false);
                      props.setSearchByValueClick(false);
                      props.setSearchBy(e.value);
                      setVisibleSearch(false);
                    }
                  }}
                  options={countries}
                  optionLabel="name"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (e.target.textContent === "Advance Search") {
                    }
                  }}
                  itemTemplate={countryTemplate}
                  className="w-full "
                  listStyle={{ maxHeight: "25rem" }}
                />
              </div>
              <div className="flex  ">
                <Sidebar
                  closeable={false}
                  style={{ width: "40.8rem" }}
                  visible={visibleRight}
                  position="right"
                  onHide={() => setVisibleRight(false)}
                >
                  <div
                    className="flex justify-content-start align-items-center"
                    style={{
                      height: "2.5rem",
                      width: "11.6rem",
                      marginTop: "1.5rem",
                    }}
                  >
                    <button
                      className={allNotification ? "allbtnactive" : "allbtn"}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setUnreadNotification(false);
                        setAllNotification(true);
                      }}
                    >
                      ALL
                    </button>
                    <button
                      className={
                        unreadNotification ? "unreadbtnactive" : "unreadbtn"
                      }
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setUnreadNotification(true);
                        setAllNotification(false);
                      }}
                    >
                      Unread
                    </button>
                  </div>
                  <hr />
                  {/* <div style={{ cursor: "pointer" }} className="notificationunread">
                                        <div className="innernotification flex align-items-start justify-content-start " style={{ marginLeft: "-1.5rem" }}>
                                            <div className="tooltip-container mt-2">
                                                <SinptelNotification />
                                                <span className="custom-tooltip"> ToolTip</span>
                                            </div>
                                            <div className="flex flex-column align-items-start justify-content-start ml-4" style={{ paddingTop: "0.2rem" }}>
                                                <h2>Monthly Summary for Nov, 2024</h2>
                                                <p>November summary is ready! Check key stats across modules.</p>
                                                <div className="flex w-full justify-content-between" style={{ cursor: "pointer" }}>
                                                    <h5>Thursday Nov, 14</h5>
                                                    <span onClick={() => setnotesidebar(true)} style={{ fontSize: "1.2rem", color: "#475CED", fontWeight: "600" }}>
                                                        View Full Summary
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                  {unreadNotification
                    ? unreadNotes.map((item, index) => (
                        <div
                          key={index}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleNavigate(item?.customerId);
                            setVisibleRight(false);
                            handleReadNotification(item?._id);
                            props.setHandleHighlight(item?.noteId);
                          }}
                          className={
                            item?.read
                              ? "notificationread"
                              : "notificationunread"
                          }
                        >
                          <div
                            className="innernotification flex align-items-start justify-content-start "
                            style={{ marginLeft: "-1.5rem" }}
                          >
                            {/* <div className="tooltip-container">
                                                          <Prepaidnotification />
                                                          <span className="custom-tooltip"> ToolTip</span>
                                                      </div> */}
                            <div
                              className="flex flex-column align-items-start justify-content-start ml-4"
                              style={{ paddingTop: "0.2rem" }}
                            >
                              {/* <h2>New Prepaid SIM Activation Request</h2> */}
                              <p>{item.message}</p>
                              <span style={{ cursor: "pointer" }}>
                                <h5
                                  style={{ fontSize: "1.2rem" }}
                                  onClick={() => {
                                    handleReadNotification(item?._id);
                                  }}
                                >
                                  {new Date(item?.timestamp).toLocaleDateString(
                                    "en-US",
                                    {
                                      weekday: "long",
                                      month: "short",
                                      day: "numeric",
                                    },
                                  )}
                                </h5>
                              </span>
                            </div>
                          </div>
                        </div>
                      ))
                    : notification.map((item, index) => (
                        <div
                          key={index}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleNavigate(item?.customerId);
                            setVisibleRight(false);
                            handleReadNotification(item?._id);
                            props.setHandleHighlight(item?.noteId);
                          }}
                          className={
                            item?.read
                              ? "notificationread"
                              : "notificationunread"
                          }
                        >
                          <div
                            className="innernotification flex align-items-start justify-content-start "
                            style={{ marginLeft: "-1.5rem" }}
                          >
                            {/* <div className="tooltip-container">
                                                          <Prepaidnotification />
                                                          <span className="custom-tooltip"> ToolTip</span>
                                                      </div> */}
                            <div
                              className="flex flex-column align-items-start justify-content-start ml-4"
                              style={{ paddingTop: "0.2rem" }}
                            >
                              {/* <h2>New Prepaid SIM Activation Request</h2> */}
                              <p>{item.message}</p>
                              <span style={{ cursor: "pointer" }}>
                                <h5
                                  style={{ fontSize: "1.2rem" }}
                                  onClick={() => {
                                    handleReadNotification(item?._id);
                                  }}
                                >
                                  {new Date(item?.timestamp).toLocaleDateString(
                                    "en-US",
                                    {
                                      weekday: "long",
                                      month: "short",
                                      day: "numeric",
                                    },
                                  )}
                                </h5>
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}
                </Sidebar>
              </div>
              <div className="flex justify-content-center align-items-center  ">
                <Sidebar
                  className="flex justify-content-center align-items-center "
                  closeable={false}
                  style={{ width: "80.8rem" }}
                  visible={profileSetting}
                  position="right"
                  onHide={() => setProfileSetting(false)}
                >
                  {showeditprofile ? (
                    <div>
                      <div className="userprofilemain">
                        <div className="profileinfo">
                          <div
                            className="profilename"
                            onClick={() => setUserDropdown((prev) => !prev)}
                          >
                            <div>
                              <button>
                                {userData1?.picture ? (
                                  <img
                                    style={{
                                      width: "8rem",
                                      height: "8rem",
                                      marginleft: "-1rem",
                                    }}
                                    src={`${process.env.REACT_APP_BASE_URL}/${userData1.picture.replace(/^uploads\//, "")}`}
                                    alt={userData1?.name || "User"}
                                    onError={(e) => {
                                      e.target.style.display = "none";
                                    }}
                                  />
                                ) : (
                                  <span
                                    className="profilename"
                                    style={{
                                      fontSize: "2.8rem",
                                      fontWeight: "500",
                                      color: "#9C9EB6",
                                    }}
                                  >
                                    {userData1?.name
                                      ? userData1.name
                                          .split(" ") // Split the name into words
                                          .map((word) =>
                                            word.charAt(0).toUpperCase(),
                                          ) // Get the first letter of each word and capitalize
                                          .join("") // Join the letters
                                      : "NA"}{" "}
                                    {/* Default fallback */}
                                  </span>
                                )}
                              </button>
                            </div>
                            <div className="mailinfoedit">
                              <button
                                className="deletepic"
                                onClick={() => {
                                  setIsDeleteChecked((prev) => !prev);
                                }}
                              >
                                Delete Picture
                              </button>
                              <div>
                                <div>
                                  <FileUpload
                                    mode="basic"
                                    name="demo[]"
                                    accept="image/*"
                                    customUpload
                                    uploadHandler={customBase64Uploader}
                                    chooseLabel={uploadedFileName}
                                    auto
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="profileeditbtn"
                            onClick={() => {
                              setShoweditprofile(true);
                            }}
                          >
                            <span className="actionbtnmain">
                              <Edit />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="userprofiledetails">
                        <div className="userprofiledetailsinner">
                          <div className="flex flex-row w-full justify-content-between">
                            <div>
                              <h1>Details</h1>
                            </div>
                          </div>
                          <div className="flex flex-column w-full justify-content-between mt-2">
                            <div className="flex w-full justify-content-between">
                              <label
                                className={
                                  formik.touched.fullName &&
                                  formik.errors.fullName
                                    ? "labelerr"
                                    : " "
                                }
                              >
                                Full Name
                              </label>
                              {formik.touched.fullName &&
                              formik.errors.fullName ? (
                                <span className="err">
                                  {formik.errors.fullName}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <InputText
                              id="fullName"
                              className={
                                formik.touched.fullName &&
                                formik.errors.fullName
                                  ? "inputfielderr mt-2"
                                  : "inputfield mt-2"
                              }
                              type="text"
                              value={formik.values.fullName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            ></InputText>
                          </div>

                          <div className="flex flex-column w-full justify-content-between mt-5">
                            <label> Company Name</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={userData?.companyName}
                              disabled
                            ></InputText>
                          </div>
                          <div className="flex flex-column w-full justify-content-between mt-5">
                            <label>Email</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={userData?.email}
                              disabled
                            ></InputText>
                          </div>
                          <div className="flex flex-column w-full justify-content-between mt-5">
                            <label>Role</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={userData?.role?.role}
                              disabled
                            ></InputText>
                          </div>
                          <div
                            className="flex flex-column w-full justify-content-between mt-5"
                            style={{ marginBottom: "4rem" }}
                          >
                            <label> Department</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={department}
                              disabled
                            ></InputText>
                          </div>
                          <div className="flex w-full justify-content-end">
                            <button
                              className="backbtn"
                              onClick={() => {
                                formik.setFieldValue(
                                  "fullName",
                                  userData.userName,
                                );

                                setShoweditprofile(false);
                              }}
                            >
                              Back
                            </button>
                            <div
                              className=" flex justify-content-center"
                              style={{ marginLeft: "1rem" }}
                            >
                              <Button
                                type="submit"
                                label="Update"
                                className="submitbtn"
                                onClick={() => {
                                  formik.handleSubmit();
                                  setProfileSetting((prev) => !prev);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="userprofilemain">
                        <div className="profileinfo">
                          <div
                            className="profilename"
                            onClick={(e) => {
                              e.stopPropagation();
                              setUserDropdown((prev) => !prev);
                            }}
                          >
                            <div>
                              <button>
                                {userData1?.picture ? (
                                  <img
                                    style={{
                                      width: "8rem",
                                      height: "8rem",
                                      marginleft: "-1rem",
                                    }}
                                    src={`${process.env.REACT_APP_BASE_URL}/${userData1.picture.replace(/^uploads\//, "")}`}
                                    alt={userData1?.name || "User"}
                                    onError={(e) => {
                                      e.target.style.display = "none";
                                    }}
                                  />
                                ) : (
                                  <span
                                    className="profilename"
                                    style={{
                                      fontSize: "2.8rem",
                                      fontWeight: "500",
                                      color: "#9C9EB6",
                                    }}
                                  >
                                    {userData1?.name
                                      ? userData1.name
                                          .split(" ") // Split the name into words
                                          .map((word) =>
                                            word.charAt(0).toUpperCase(),
                                          ) // Get the first letter of each word and capitalize
                                          .join("") // Join the letters
                                      : "NA"}{" "}
                                    {/* Default fallback */}
                                  </span>
                                )}
                              </button>
                            </div>
                            <div className="mailinfo">
                              <h1>{userData1?.name}</h1>
                              <p>{userData?.email}</p>
                            </div>
                          </div>
                          <div
                            className="profileeditbtn"
                            onClick={() => {
                              setShoweditprofile(true);
                            }}
                          >
                            <span className="actionbtnmain">
                              {" "}
                              <Edit />
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="userprofiledetails">
                        <div className="userprofiledetailsinner">
                          <div className="flex flex-row w-full justify-content-between">
                            <div>
                              <h1>Details</h1>
                            </div>
                            {/* <div>
                                                        <h5>
                                                            User Id : <span> ETC12345</span>
                                                        </h5>
                                                    </div> */}
                          </div>
                          <div className="flex flex-column w-full justify-content-between mt-5">
                            <label> Full Name</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={formik.values.fullName}
                              contentEditable={false}
                            ></InputText>
                          </div>
                          {/* <div className="flex flex-column w-full justify-content-between mt-5">
                                                    <label> Last Name</label>
                                                    <InputText className="inputfield mt-2" type="text" value={"Wick"} contentEditable={false}></InputText>
                                                </div> */}
                          <div className="flex flex-column w-full justify-content-between mt-5">
                            <label> Company Name</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={userData?.companyName}
                              contentEditable={false}
                            ></InputText>
                          </div>
                          <div className="flex flex-column w-full justify-content-between mt-5">
                            <label>Email</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={userData?.email}
                              contentEditable={false}
                            ></InputText>
                          </div>
                          <div className="flex flex-column w-full justify-content-between mt-5">
                            <label>Role</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={userData?.role?.role}
                              contentEditable={false}
                            ></InputText>
                          </div>
                          <div
                            className="flex flex-column w-full justify-content-between mt-5"
                            style={{ marginBottom: "4rem" }}
                          >
                            <label> Department</label>
                            <InputText
                              className="inputfield mt-2"
                              type="text"
                              value={department}
                              contentEditable={false}
                            ></InputText>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </Sidebar>
              </div>
            </div>
            <div className="appsicons">
              <div
                className="flex  w-full bggradapps"
                style={{ position: "fixed", zIndex: "0", height: "100%" }}
              >
                <Loginbg />
              </div>
              <div
                className="flex flex-column justify-content-center align-items-center w-full"
                style={{ zIndex: "0" }}
              >
                <h1>Effortless Telecom Navigation Simplified for You</h1>
                <div className="mainappicons">
                  {props.model[0]?.items?.map((element, index) => {
                    return (
                      <div
                        key={index}
                        className="iconcontainer"
                        onClick={() => {
                          props.setShowApps(false);
                          setCustomerProfileIcon(false);
                          navigate(element.subModules[0].route);
                        }}
                        //  onMouseEnter={() => setCustomerProfileIcon(true)}
                        // onMouseLeave={() => setCustomerProfileIcon(false)}
                      >
                        <div
                          className={`main-app-container-top ${CustomerProfileIcon ? "appinnerhover" : "appinner"}`}
                        >
                          <div
                            className="main-app-container-icon"
                            dangerouslySetInnerHTML={{ __html: element?.icon }}
                          />
                          <h3>{element.moduleName}</h3>
                          <p>{element?.description}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <Sidebar
        closeable={false}
        style={{ width: "80.8rem" }}
        visible={notesidebar}
        position="right"
        onHide={() => setnotesidebar(false)}
      >
        <div className="monthlymain ">
          <div className="monthlyinner">
            <div className="header">
              <div>
                <img src="./monthlysniptel.png" alt="" />
              </div>
              <div className="flex flex-column">
                <h1>Monthly & Weekly Insights</h1>
                <p>
                  Track module performance with Sniptel's weekly and monthly
                  insights.
                </p>
              </div>
            </div>
            <div className="count mt-5">
              <div
                className={monthlyNote ? "monthlyactive " : "monthly"}
                style={{
                  cursor: "pointer",
                  borderBottom: monthlyNote ? "1px solid #475CED" : "",
                }}
                onClick={() => {
                  setMonthlyNotes(true);
                  setWeeklyNotes(false);
                }}
              >
                <p>
                  Monthly <span className="span">25</span>
                </p>
              </div>
              <div
                className={weeklyNotes ? "weeklyactive" : "weekly"}
                style={{
                  cursor: "pointer",
                  borderBottom: weeklyNotes ? "1px solid #475CED" : "",
                }}
                onClick={() => {
                  setMonthlyNotes(false);
                  setWeeklyNotes(true);
                }}
              >
                <p>
                  Weekly <span className="span">25</span>
                </p>
              </div>
            </div>

            <div className="maindata ">
              <div className="innerdata mt-3">
                <div className="ml-4" style={{ marginTop: "1.2rem" }}>
                  <Prepaidnotification />
                </div>
                <div className="flex flex-column justify-content-center ml-4 notedata">
                  <h1>Prepaid</h1>
                  <p>
                    In Prepaid, 10 new orders were added, 8 customers were
                    activated, and 30 are pending activation
                  </p>{" "}
                </div>
              </div>
              <div className="innerdata mt-3">
                <div className="ml-4" style={{ marginTop: "1.2rem" }}>
                  <Prepaidnotification />
                </div>
                <div className="flex flex-column justify-content-center ml-4 notedata">
                  <h1>Prepaid</h1>
                  <p>
                    In Prepaid, 10 new orders were added, 8 customers were
                    activated, and 30 are pending activation
                  </p>{" "}
                </div>
              </div>
              <div className="innerdata mt-3">
                <div className="ml-4" style={{ marginTop: "1.2rem" }}>
                  <Prepaidnotification />
                </div>
                <div className="flex flex-column justify-content-center ml-4 notedata">
                  <h1>Prepaid</h1>
                  <p>
                    In Prepaid, 10 new orders were added, 8 customers were
                    activated, and 30 are pending activation
                  </p>{" "}
                </div>
              </div>
              <div className="innerdata mt-3">
                <div className="ml-4" style={{ marginTop: "1.2rem" }}>
                  <Prepaidnotification />
                </div>
                <div className="flex flex-column justify-content-center ml-4 notedata">
                  <h1>Prepaid</h1>
                  <p>
                    In Prepaid, 10 new orders were added, 8 customers were
                    activated, and 30 are pending activation
                  </p>{" "}
                </div>
              </div>
              <div className="innerdata mt-3">
                <div className="ml-4" style={{ marginTop: "1.2rem" }}>
                  <Prepaidnotification />
                </div>
                <div className="flex flex-column justify-content-center ml-4 notedata">
                  <h1>Prepaid</h1>
                  <p>
                    In Prepaid, 10 new orders were added, 8 customers were
                    activated, and 30 are pending activation
                  </p>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};
